module.exports = __webpack_public_path__ + "static/media/technology.06b0c77d.jpg";